{
  "name": "dms-front",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:stage": "ng serve --configuration=stage",
    "build": "ng build",
    "build:stage": "ng build --configuration=stage",
    "build:pre-production": "ng build --configuration=pre-production && npm run sentry:sourcemaps",
    "build:production": "ng build --configuration=production && npm run sentry:sourcemaps",
    "watch": "ng build --watch --configuration stage",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "pre-commit": "lint-staged --relative --config lint-staged.config.js && jest && ng build",
    "sonar": "node sonar.js",
    "prepare": "husky install",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org apteka-911 --project dms-frontend dist/dms-front && sentry-cli --url https://sentry.agilie.com/ sourcemaps upload --org apteka-911 --project dms-frontend dist/dms-front",
    "test": "jest",
    "test:coverage": "jest --coverage",
    "test:ci": "jest --ci --runInBand"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.27",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.27",
    "@angular/compiler": "^20.3.27",
    "@angular/core": "^20.3.27",
    "@angular/forms": "^20.3.27",
    "@angular/localize": "^20.3.27",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.27",
    "@angular/platform-browser-dynamic": "^20.3.27",
    "@angular/router": "^20.3.27",
    "@apollo/client": "^3.0.0",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@ng-select/ng-select": "^20.7.0",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@ngxs/store": "^20.1.0",
    "@sentry/angular": "^9.47.1",
    "@sentry/cli": "^2.36.2",
    "@types/jest": "^30.0.0",
    "apollo-angular": "^11.0.0",
    "date-fns": "^3.4.0",
    "dayjs": "^1.11.13",
    "dayjs-plugin-utc": "^0.1.2",
    "eventsource": "^3.0.2",
    "graphql": "^16",
    "jest": "^30.0.0",
    "jest-environment-jsdom": "^30.0.0",
    "jest-preset-angular": "^16.1.5",
    "leaflet": "^1.9.4",
    "leaflet-draw": "^1.0.4",
    "leaflet-routing-machine": "^3.2.12",
    "leaflet.markercluster": "^1.5.3",
    "lodash-es": "^4.17.21",
    "ngx-mask": "^20.0.0",
    "rxjs": "~7.8.0",
    "sonarqube-scanner": "^3.0.1",
    "ts-jest": "^29.4.6",
    "ts-node": "^10.9.2",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.32",
    "@angular-eslint/eslint-plugin-template": "^20.7.0",
    "@angular/cli": "^20.3.32",
    "@angular/compiler-cli": "^20.3.27",
    "@eslint/js": "^8.57.0",
    "@popperjs/core": "^2.11.8",
    "@types/geojson": "^7946.0.14",
    "@types/leaflet": "^1.9.4",
    "@types/leaflet-draw": "^1.0.11",
    "@types/leaflet-routing-machine": "^3.2.8",
    "@types/leaflet.markercluster": "^1.5.5",
    "@types/lodash-es": "4.17.12",
    "@typescript-eslint/eslint-plugin": "^8.60.0",
    "@typescript-eslint/parser": "^8.60.0",
    "eslint": "^8.57.1",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-jsdoc": "^48.5.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^5.1.3",
    "eslint-plugin-rxjs": "^5.0.3",
    "eslint-plugin-security": "^3.0.1",
    "eslint-plugin-simple-import-sort": "^12.1.0",
    "eslint-plugin-stylelint": "^0.1.1",
    "globals": "^15.7.0",
    "husky": "^9.0.11",
    "lint-staged": "^15.2.7",
    "prettier": "^3.3.2",
    "stylelint": "^16.6.1",
    "typescript": "~5.8.3",
    "typescript-eslint": "^8.60.0"
  },
  "husky": {
    "hooks": {
      "pre-commit": "npm run lint -- --max-warnings=0"
    }
  }
}
